import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import './Achievements.css';

const ICON_MAP = {
  target: '&#9654;', star: '&#11088;', flame: '&#128293;', zap: '&#9889;',
  cpu: '&#9632;', settings: '&#9881;', globe: '&#9670;', shield: '&#9670;',
  code: '&#9670;', trophy: '&#127942;', 'trending-up': '&#8679;', award: '&#9830;',
};

export default function Achievements() {
  const { unlockedAchievements } = useGame();
  const [achievements, setAchievements] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetch('/api/achievements')
      .then(r => r.json())
      .then(setAchievements)
      .catch(() => {});
  }, []);

  const categories = ['all', 'milestone', 'skill', 'topic'];
  const filtered = filter === 'all' ? achievements : achievements.filter(a => a.category === filter);
  const unlocked = achievements.filter(a => unlockedAchievements.includes(a.id)).length;

  return (
    <div>
      <div className="section-header" style={{ marginBottom: 28 }}>
        <div>
          <h1 className="section-title" style={{ fontSize: '1.8rem' }}>Achievements</h1>
          <p className="section-subtitle">{unlocked}/{achievements.length} unlocked</p>
        </div>
        <div className="ach-progress-pill">
          <div className="ach-progress-fill" style={{ width: `${achievements.length ? (unlocked / achievements.length) * 100 : 0}%` }} />
          <span className="ach-progress-label">{unlocked}/{achievements.length}</span>
        </div>
      </div>

      <div className="ach-filters">
        {categories.map(c => (
          <button
            key={c}
            className={`btn btn-sm ${filter === c ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilter(c)}
          >
            {c.charAt(0).toUpperCase() + c.slice(1)}
          </button>
        ))}
      </div>

      <div className="ach-grid">
        {filtered.map(a => {
          const isUnlocked = unlockedAchievements.includes(a.id);
          return (
            <div key={a.id} className={`ach-card card ${isUnlocked ? 'unlocked' : 'locked'}`}>
              <div className={`ach-icon-wrap ${isUnlocked ? 'unlocked' : ''}`}
                dangerouslySetInnerHTML={{ __html: ICON_MAP[a.icon] || '&#9670;' }}
              />
              {!isUnlocked && <div className="ach-lock">&#128274;</div>}
              <div className="ach-info">
                <div className="ach-title">{a.title}</div>
                <div className="ach-desc">{a.description}</div>
                <div className="ach-reward">
                  <span className="xp-chip">+{a.xp_reward} XP</span>
                  <span className="ach-cat-tag">{a.category}</span>
                </div>
              </div>
              {isUnlocked && <div className="ach-unlocked-badge">&#10003;</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
